/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesComplexityDto } from '../../models/sales-complexity-dto';
import { SalesPriceListResponseDto } from '../../models/sales-price-list-response-dto';

export interface PriceListsControllerUpdateComplexity$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the price list.
 */
  id: string;

/**
 * The code of the complexity to update.
 */
  complexityCode: string;
      body: SalesComplexityDto
}

export function priceListsControllerUpdateComplexity(http: HttpClient, rootUrl: string, params: PriceListsControllerUpdateComplexity$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesPriceListResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, priceListsControllerUpdateComplexity.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.path('complexityCode', params.complexityCode, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesPriceListResponseDto>;
    })
  );
}

priceListsControllerUpdateComplexity.PATH = '/o2-sales/price-lists/{tenant}/{id}/complexities/{complexityCode}';
